import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import * as React from 'react';
// @mui
import { Container, Typography, Stack, Button, IconButton } from '@mui/material';
// Tabela
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Iconify from '../../../components/iconify';
import FilterField from '../components/FilterField';
import Fluxo from '../Fluxograma/Fluxo';

// api
import { validateUser, getOss, createOs, deleteOs } from '../../api';
import config from '../../../config.json';
import PopoverFiltroOs from '../../PopoverFiltroOs';
import ModalLoading from '../../ModalLoading';
import ModalConfirmacao from '../../ModalConfirmacao';
// import ModalMensagem from '../../ModalMensagem';
import { cores } from '../../../styles/styleUtils';

import NewSaleForm from '../NewOs/NewOsForm';

// ----------------------------------------------------------------------

export default function Os() {
  const [propostas, setPropostas] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [isNewSaleModalOpen, setIsNewSaleModalOpen] = useState(false);
  const [isFluxoOpen, setIsFluxoOpen] = useState(false);
  const [produto, setProduto] = React.useState(null);
  const usuarioLogado = JSON.parse(localStorage.getItem('userData'));
  const [modalConfirmacaoDelete, setModalConfirmacaoDelete] = useState(false);
  // const [openModalMensagem, setOpenModalMensagem] = useState(false);

  const navigate = useNavigate();
  // Filtro ----
  const dataAtual = new Date();
  const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1).toISOString().split('T')[0];
  const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0).toISOString().split('T')[0];
  const emptyFiltro = {
    usuarioLogado,
    dataInicio: primeiroDiaDoMes,
    dataFim: ultimoDiaDoMes,
    unidades: [],
    classificacoes: [],
    responsaveis: [],
    fornecedores: [],
    distribuidoras: [],
  };
  const [filtro, setFiltro] = useState({ ...emptyFiltro });
  const [openFiltro, setOpenFiltro] = useState(null);

  useEffect(() => {
    validateuser();
  }, []);
  const validateuser = async () => {
    const teste = await validateUser();
    if (!teste.ok) {
      localStorage.removeItem('userData');
      localStorage.removeItem('userToken');
      config.user = {};
      navigate('/', { replace: true });
      window.alert('Sessão expirada, faça o login novamente');
      return;
    }
    localStorage.setItem('userData', JSON.stringify(teste.usuario));
    config.user = teste.usuario;
  };

  const fGetPropostas = useCallback(async (filtro) => {
    try {
      const result = await getOss(filtro);
      setPropostas(result);
    } catch (error) {
      window.alert('Erro ao consultar banco de dados');
      console.error('Erro ao buscar dados da API:', error);
    }
  }, []);

  useEffect(() => {
    fGetPropostas(filtro);
  }, [filtro, fGetPropostas]);

  const handleOpenNewSaleModal = () => {
    setIsNewSaleModalOpen(true);
  };

  const handleCloseNewSaleModal = () => {
    setIsNewSaleModalOpen(false);
    setIsFluxoOpen(false);
    setProduto(null);
  };

  const handleDoubleClickTable = async (row) => {
    setProduto({ ...row, visualiza: true });
    if (row.codigo) {
      setIsFluxoOpen(true);
      return;
    }
    setIsNewSaleModalOpen(true);
  };

  const onCloseFiltro = () => {
    setOpenFiltro(null);
  };

  const limparFiltro = () => {
    setFiltro({ ...emptyFiltro });
    setOpenFiltro(null);
  };

  const onConfirmFiltro = (filtroPopover) => {
    setFiltro(filtroPopover);
    setOpenFiltro(null);
  };

  const handleDeleteClick = (row) => {
    setProduto({ ...row });
    setModalConfirmacaoDelete(true);
  };

  const closeModalConfirmacaDelete = () => {
    setModalConfirmacaoDelete(false);
    setProduto(null);
  };

  const confirmDelete = async () => {
    setModalLoading(true);
    await deleteOs(produto);
    closeModalConfirmacaDelete();
    fGetPropostas(filtro);
    setProduto(null);
    setModalLoading(false);
  };

  const onConfirmNewSale = async (data) => {
    setModalLoading(true);
    try {
      const responseOs = await createOs(data);
      if (!responseOs || !responseOs.success) {
        window.alert(responseOs?.message || 'Erro ao salvar a OS. Tente novamente.');
      }
      if (responseOs.warning) {
        window.alert(
          'Erro ao enviar a mensagem automática para o cliente, verifique a conexão do WhatsApp e o telefone do cliente'
        );
      }
    } catch (error) {
      window.alert('Erro ao salvar a OS');
      console.log('error');
    }
    setModalLoading(false);
    fGetPropostas(filtro);
    handleCloseNewSaleModal();
  };

  // Novo estado para o termo de busca
  const [searchTerm, setSearchTerm] = useState('');
  // Novo estado para os dados filtrados
  const [filteredPropostas, setFilteredPropostas] = useState([]);

  // Este useEffect reagirá a mudanças em 'propostas' ou 'searchTerm'
  useEffect(() => {
    const results = propostas.filter((row) => {
      const descricaoMatch = row.cliente?.nome?.toLowerCase().includes(searchTerm.toLowerCase());
      const descricaoMatch2 = row.vendedorAbertura?.nome?.toLowerCase().includes(searchTerm.toLowerCase());
      const descricaoMatch3 = row.vendedorFechamento?.nome?.toLowerCase().includes(searchTerm.toLowerCase());
      return descricaoMatch || descricaoMatch2 || descricaoMatch3;
    });
    setFilteredPropostas(results);
  }, [searchTerm, propostas]);
  // ----------------------

  // ----------------------

  return (
    <>
      <Helmet>
        <title> OS </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography variant="h4" sx={{ mb: 5 }}>
            OS
          </Typography>

          <Button
            onClick={(e) => setOpenFiltro(e.currentTarget)}
            variant="contained"
            startIcon={<Iconify icon="eva:search-fill" />}
            sx={{
              height: 50,
              minWidth: 100,
              backgroundColor: cores.laranja,
              marginLeft: 'auto',
              '&:hover': { backgroundColor: cores.laranjaEscuro },
            }}
          >
            Filtros
          </Button>

          <Button
            variant="contained"
            onClick={handleOpenNewSaleModal}
            startIcon={<Iconify icon="zondicons:add-solid" />}
            sx={{ height: 50, minWidth: 100, marginLeft: 1 }}
          >
            Adicionar
          </Button>
        </Stack>

        <FilterField
          setSearchTerm={setSearchTerm}
          searchTerm={searchTerm}
          label={'Filtrar por nome cliente ou vendedor'}
        />

        {/* ------------ Tabela ------------ */}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Cliente</TableCell>
                <TableCell align="left">Abertura</TableCell>
                <TableCell align="left">Unidade</TableCell>
                <TableCell align="center">Data</TableCell>
                <TableCell align="center">Responsável</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell align="center">Codigo</TableCell>
                <TableCell align="center">{''}</TableCell>
                {usuarioLogado.supervisor && <TableCell align="center"> </TableCell>}
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredPropostas.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                    '&:hover': { backgroundColor: cores.cinzaClaro },
                    ...(row.finalizado?.nome === 'Rejeitado' && {
                      color: 'red',
                      textDecoration: 'line-through',
                    }),
                  }}
                  onDoubleClick={() => handleDoubleClickTable(row)}
                >
                  <TableCell align="left">{row.cliente.nome}</TableCell>
                  <TableCell align="left">{row.user?.nome}</TableCell>
                  <TableCell align="left">{row.unidade?.nome}</TableCell>
                  <TableCell align="center">
                    {new Date(row.data).toLocaleDateString('pt-BR', {
                      timeZone: 'UTC',
                    })}
                  </TableCell>
                  <TableCell align="center">{row.responsavelExecucao?.nome}</TableCell>
                  {/* Ícone de exclusão visível apenas para supervisores */}
                  <TableCell align="center">{row.status}</TableCell>
                  <TableCell align="center">{row.codigo}</TableCell>
                  <TableCell align="center">
                    <IconButton onClick={() => handleDoubleClickTable(row)}>
                      <Iconify icon="mdi:pencil" width={24} height={24} />
                    </IconButton>
                  </TableCell>
                  {usuarioLogado.supervisor && (
                    <TableCell align="center">
                      <IconButton onClick={() => handleDeleteClick(row)}>
                        <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
              <TableRow>
                <TableCell align="left" colSpan={4}>
                  <strong>Total</strong>
                </TableCell>
                <TableCell align="center">
                  Quantidade: <strong>{propostas.length}</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>
                    {propostas
                      .reduce((acc, curr) => acc + (curr.valor || 0), 0)
                      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </strong>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      {openFiltro ? (
        <PopoverFiltroOs
          filtro={filtro}
          open={openFiltro}
          onClose={onCloseFiltro}
          onLimpar={limparFiltro}
          onConfirm={onConfirmFiltro}
        />
      ) : null}
      {/* Modal Loading */}
      {modalLoading && <ModalLoading open={modalLoading} />}

      {modalConfirmacaoDelete && (
        <ModalConfirmacao
          title={'Tem certeza que deseja excluir essa OS?'}
          subtitle={`${produto.cliente?.nome} - ${new Date(produto.data).toLocaleDateString()} - ${produto.codigo}`}
          open={modalConfirmacaoDelete}
          onClose={closeModalConfirmacaDelete}
          onConfirm={confirmDelete}
        />
      )}

      {isNewSaleModalOpen && (
        <NewSaleForm
          open={isNewSaleModalOpen}
          formData={produto}
          handleClose={handleCloseNewSaleModal}
          onConfirm={onConfirmNewSale}
        />
      )}

      {isFluxoOpen && (
        <Fluxo open={isFluxoOpen} proposta={produto} onClose={handleCloseNewSaleModal} onConfirm={onConfirmNewSale} />
      )}

      {/* openModalMensagem && <ModalMensagem open={openModalMensagem} /> */}
    </>
  );
}